import React, {useEffect, useMemo, useState} from "react";
import Form from "react-bootstrap/Form";
import {Button} from "react-bootstrap";
import {openCurr, saveOpenedCurrency} from "../../utils/utils";

function OpenCurrency(props) {

    const [currency, setCurrency] = useState('');

    const openCurrency = (e) => {
        if (currency) {
            saveOpenedCurrency(currency)
            openCurr(currency);
        }
    }

    return (
        <Form className={props.formClass} onSubmit={(e) => {
            e.preventDefault();
            openCurrency();
        }}>
            <Form.Group className="mb-1" controlId="comment">
                <div className="d-flex">
                    <Form.Control
                        placeholder="Open currency"
                        className="me-2"
                        onChange={(e) => setCurrency(e.target.value)}/>
                    <Button variant="primary" onClick={openCurrency}>Submit</Button>
                </div>
            </Form.Group>
        </Form>
    );
}

export default OpenCurrency;
